import React from "react";
import loader from './../../static/css/loader.module.css';
function MrbgLoader(){

  return <div id={loader.mrbgLoader} data-id="mrbgLoader">
      <div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div>loading...</div>
    </div>
}

export default MrbgLoader;